<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<img src="../../assets/bookok.png" >
				<h3>预约成功</h3>
				<div class="fcc">
					<div class="button-blue" @click="show=false">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-book-ok',
		props: {
			msg: String
		},
		data() {
			return {
				//timer:null,
				show:true
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			
		},
		beforeDestroy() {
			//clearTimeout(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
		.inner{
			padding-top: 76px;
			text-align: center;
			img{
				height: 457px;
				margin-bottom: 75px;
			}
			h3{
				font-size: 66px;
				color: #3C90F0;
				line-height: 1.1em;font-weight: bold;
				margin-bottom: 50px;
			}
		}
</style>
